import React from "react";

const TestimonialCard = (props) => {
  return (
    <div className="testimonial">
      <img src={props.image} alt="" />

      <p>{props.name}</p>

      <p></p>
      <p>{props.testimony}</p>

      <p className="star">&#9733;&#9733;&#9733;&#9733;&#9733;</p>
    </div>
  );
};

export default TestimonialCard;
